import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@project-mgmt/feature-auth";
import { PageErrorBoundary } from "./components/ErrorBoundary";
import { routes } from "./router";
import { ToastProvider } from "./providers/ToastProvider";

function App() {
  return (
    <PageErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          {routes}
          <ToastProvider />
        </BrowserRouter>
      </AuthProvider>
    </PageErrorBoundary>
  );
}

export default App;
